import {CommandRequester} from '../CommandRequester';
import RequestToken from '../tokens/RequestToken';

export default abstract class RequestAPI<R extends JIBO.v1.BaseCommand, T extends RequestToken<R>> {
    protected owner:CommandRequester;

    constructor(owner:CommandRequester) {
        this.owner = owner;
    }

    abstract generateToken(protocol: R): T;

    public sendToken(token: T): void {
        this.owner.sendToken(token);
    }
}